__turbopack_context__.v({
  "calculatorFixedButton": "styles-module__kIT51W__calculatorFixedButton",
  "colorSelect": "styles-module__kIT51W__colorSelect",
  "privilegeDetailRow": "styles-module__kIT51W__privilegeDetailRow",
  "privilegeItemRow": "styles-module__kIT51W__privilegeItemRow",
  "privilegeItemRowDetail": "styles-module__kIT51W__privilegeItemRowDetail",
  "resultRowTemplate": "styles-module__kIT51W__resultRowTemplate",
});
